<template lang="pug">
.content.text-center.p-24
  h2 Profile

  .field
    label.block.text-xs(for="name") Name
    input.h-8.my-4.px-4.py-2.border(type="text" name="name" v-model="current.name")
  .field
    label.block.text-xs(for="alias") Alias
    input.h-8.my-4.px-4.py-2.border(type="text" name="alias" v-model="current.alias")
  //- .field
  //-   label.block.text-xs(for="code") Code
  //-   input.h-8.my-4.px-4.py-2.border(type="text" name="code" v-model="current.code")

  .btn(@click="save") Save

</template>

<script>

import LoginApi from '@/plugins/LoginApi'

export default {
  name: 'Profile',
  data: () => ({
    current: {
      name: '',
      alias: '',
      code: ''
    }
  }),
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  mounted () {
    let { name, alias, code } = this.user
    this.current = { name, alias, code }
  },
  methods: {
    async save () {
      if (this.current.name !== this.user.name) {
        await LoginApi.updateName(this.current.name)
      }

      if (this.current.alias !== this.user.alias) {
        await LoginApi.updateAlias(this.current.alias)
      }

      this.$store.dispatch('refresh')
    }
  }
}
</script>

<style lang="scss" scoped>

.btn-disabled
  background-color: #ddd

</script>



// WEBPACK FOOTER //
// src/pages/profile.vue